// https://vuex.vuejs.org/en/getters.html

// authorized lets you know if the token is true or not
export default {
  authorized: state => !!state.tokenWeb,
  authstatus: state => state.authStatus,
  drawer_state: state => state.drawer,
  showSnackbar: state => state.showSnackbar,
  snackbarMsg: state => state.snackbarMsg,
  showDialog: state => state.showDialog,
  dialogMsg: state => state.dialogMsg,
  snackbarColor: state => state.snackbarColor,
  showRegVaDialog: state => state.showRegVaDialog,
  showPopUpNotificationDialog: state => state.showPopUpNotificationDialog,
  vaProfile: state => state.vaProfile,
  productPartners: state => state.productPartners,
  products: state => state.products,
  isLoading: state => state.isLoading,
  allProductPaymentType: state => state.productPaymentTypeList,
  allCustomerType: state => state.customerTypeList,
  allCertSearchKey: state => state.certSearchKeyList,
  getDistType: state => state.distType,
}
